import { EffectCallback, useEffect, useMemo, useRef } from 'react';

import { useLocation } from 'react-router-dom';

// https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
export const usePrevious = <T extends unknown>(value: T): T | undefined => {
    const ref = useRef<T>();

    useEffect(() => {
        ref.current = value;
    });

    return ref.current;
};

export const useMount = (effect: EffectCallback): void => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, []);
};

export const useUpdateEffect: typeof useEffect = (effect, deps) => {
    const isFirstMount = useRef(true);

    useEffect(() => {
        if (!isFirstMount.current) effect();
        else isFirstMount.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

export const useQuery = (): URLSearchParams => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
};
